import React from 'react';
import ReactDOM from 'react-dom';
import styles from './QueueNotificationPopup.module.css';
import { FaTimes, FaRedo } from 'react-icons/fa';

const QueueNotificationPopup = ({ show, onClose, onResetFiles, title = "Generation Started" }) => {
    if (!show) return null;

    const handleClose = () => {
        if (onResetFiles) onResetFiles(); // Reset form fields
        if (onClose) onClose();           // Then close the popup
    };

    // Customize message based on title
    const getMessage = () => {
        if (title === "Deal Check Started") {
            return {
                main: "Your deal tag check request has been accepted and is being processed.",
                // sub: "You will receive an email notification when the check is complete.",
                note: "Alternatively, you can track your generation on the Top Right corner"
            };
        } else if (title === "Listing Score Started" || title === "Bulk Listing Score Started") {
            return {
                main: "Your Bulk listing scorer request has been processed.",
                // sub: "You will receive a mail when the generation is complete.",
                note: "Alternatively, you can track your generation on the Top Right corner"
            };
        } else {
            return {
                main: "Your Bulk Generation request has been processed.",
                // sub: "You will receive a mail when the generation is complete.",
                note: "Alternatively, you can track your generation on the Top Right corner"
            };
        }
    };

    const message = getMessage();

    return ReactDOM.createPortal(
        <div className={styles.overlay}>
            <div className={styles.popup}>
                <div className={styles.header}>
                    <button className={styles.closeButton} onClick={handleClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className={styles.content}>
                    <p className={styles.subMessage}>
                        {message.main}<br></br> {message.sub}
                    </p>

                    <p className={styles.smallNote}>{message.note}</p>
                </div>

                <div className={styles.navigationActions}>
                    <button
                        className={`${styles.btn} ${styles.btnPrimary}`}
                        onClick={handleClose}
                    >
                        <FaRedo />
                        {title === "Deal Check Started" ? "Check More ASINs" :
                         title === "Listing Score Started" || title === "Bulk Listing Score Started" ? "Score More ASINs" :
                         "Generate Another"}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default QueueNotificationPopup;